import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/authentication/auth-guard.service';
import { LogoutComponent } from './views/login/logout.component';

import { SignaletiqueDetailComponent } from './views/signaletique/signaletique-detail.component';
import { SignaletiqueGrilleComponent } from './views/signaletique/signaletique-grille.component';

// Import Containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent,
} from './containers';
import { LoginComponent } from './views/login/login.component';
import { AgendaComponent } from './views/agenda/agenda.component';
import { EmailComponent } from './views/communication/email/email.component';

export const routes: Routes = [
  { path: '',
    redirectTo: 'presta/agenda',
    pathMatch: 'full' },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Agenda'
    },
    children: [
      {
        path: 'presta/agenda',
        component: AgendaComponent
      },
      {
        path: 'presta/agenda/:cle',
        component: AgendaComponent
      },
      {
        path: 'admin/signaletique',
        component: SignaletiqueGrilleComponent
      },
      {
        path: 'admin/signaletique/:cle',
        component: SignaletiqueDetailComponent
      },
      {
        path: 'admin/email',
        component: EmailComponent
      }
    ]
  },
  {
    path: '',
    component: SimpleLayoutComponent,
    data: {
      title: 'Agenda'
    },
    children: [
      {
        path: 'login',
        component: LoginComponent
      }
    ]
  },
  {
    path: 'logout',
    component: LogoutComponent
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
